import { createReducer, on } from '@ngrx/store';
import { Notification } from 'src/app/model/notification';
import * as NotificationsActions from './notifications.actions';

export interface State {
  notifications: Notification[];
  toastNotification?: Notification;
  topbarTitle: string;
  showProgressSpinner: boolean;
}

export const initialState: State = {
  notifications: [],
  toastNotification: undefined,
  topbarTitle: '',
  showProgressSpinner: false,
};

export const reducer = createReducer(
  initialState,
  on(NotificationsActions.addNotification, (state, payload) => {
    const notification = payload.notification;
    if (payload.toastOnly === true) { // solo toast no lista
      return { ...state, toastNotification: notification };
    }
    if (payload.listOnly === true) { // solo lista no toast
      state.notifications.push(notification);
      return { ...state };
    }
    // default: va nella lista e mostra toast
    state.notifications.push(notification);
    return { ...state, toastNotification: notification };
  }),
  on(NotificationsActions.clearToastNotification, (state) => ({
    ...state,
    toastNotification: undefined,
  })),
  on(NotificationsActions.removeNotification, (state, payload) => ({
    ...state,
    notifications: state.notifications.filter(
      (notification, index) => index !== payload.index
    ),
  })),
  on(NotificationsActions.clearNotifications, (state) => ({
    ...state,
    notifications: [],
  })),
  on(NotificationsActions.setTopbarTitleId, (state, payload) => ({
    ...state,
    topbarTitle: payload.stringId,
  })),
  on(NotificationsActions.resetTopbarTitleId, (state) => ({
    ...state,
    topbarTitle: '',
  })),
  on(NotificationsActions.showProgressSpinner, (state) => ({
    ...state,
    showProgressSpinner: true,
  })),
  on(NotificationsActions.hideProgressSpinner, (state) => ({
    ...state,
    showProgressSpinner: false,
  }))
);
